import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { SparklesIcon } from 'lucide-react';
export function UniqueMechanism() {
  return <SectionWrapper className="bg-brand-brown text-brand-sand" data-id="element-152">
      <div className="max-w-4xl mx-auto text-center" data-id="element-153">
        <SparklesIcon className="w-12 h-12 text-brand-amber mx-auto mb-6" data-id="element-154" />
        <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8" data-id="element-155">
          Presentamos el <br data-id="element-156" />
          <span className="text-brand-amber" data-id="element-157">
            Protocolo de Reordenamiento Ancestral
          </span>
        </h2>

        <div className="space-y-6 text-lg md:text-xl font-sans text-brand-sand/90 max-w-3xl mx-auto" data-id="element-158">
          <p data-id="element-159">
            Este método no es una dieta; es un sistema de desinflamación
            diseñado específicamente para la biología de la mujer latina de 40+
            años.
          </p>
          <p className="font-semibold text-brand-amber" data-id="element-160">
            Utilizamos alimentos reales y poderosos que puedes encontrar hoy
            mismo en Costco, Walmart o Publix.
          </p>
          <p data-id="element-161">
            El objetivo es estabilizar tu azúcar en sangre, enfriar tu
            temperatura interna y darle a tu cerebro la "electricidad" que el
            descenso de estrógeno le ha quitado.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}